import { NavLink, Route, Routes } from "react-router-dom";

import { History } from "./pages/History";
import { Overview } from "./pages/Overview";
import { SettingsPage } from "./pages/Settings";

const linkClass = ({ isActive }: { isActive: boolean }): string => (isActive ? "active" : "");

export function App() {
  return (
    <>
      <header className="top">
        <div className="inner">
          <strong>Flugpreis-Tracker</strong>
          <nav>
            <NavLink to="/" end className={linkClass}>
              Übersicht
            </NavLink>
            <NavLink to="/historie" className={linkClass}>
              Historie
            </NavLink>
            <NavLink to="/einstellungen" className={linkClass}>
              Einstellungen
            </NavLink>
          </nav>
        </div>
      </header>
      <main className="shell">
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/historie" element={<History />} />
          <Route path="/einstellungen" element={<SettingsPage />} />
          <Route path="*" element={<Overview />} />
        </Routes>
      </main>
    </>
  );
}
